// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.pulsation-icon {
  display: flex;
  justify-content: center;
  align-items: center;
}

.pulsating-circle {
  width: 30px;
  height: 30px;
  border-radius: 50%;
  background: rgba(88, 137, 236, 0.8);
  animation: pulsate 1.5s ease-out;
  animation-iteration-count: infinite;
}

@keyframes pulsate {
  0% {
    transform: scale(0.1);
    opacity: 0;
  }
  50% {
    opacity: 1;
  }
  100% {
    transform: scale(1.2);
    opacity: 0;
  }
}
.google-button {
  position: fixed !important;
  z-index: 1000;
  background-color: #f36d45 !important;
  border-radius: 50% !important;
  box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.1);
  display: flex;
  justify-content: center;
  align-items: center;
  transition: transform 0.2s, box-shadow 0.2s;
  width: 30px;
  height: 50px;
  bottom: 30px;
  right: 30px;
}
.google-button:hover {
  transform: scale(1.1);
  box-shadow: 0px 8px 15px rgba(0, 0, 0, 0.2);
}
@media screen and (max-width: 768px) {
  .google-button {
    width: 30px !important;
    height: 55px;
    bottom: 20px;
    right: 20px;
    left: auto;
  }
}

.filter-section-desktop {
  position: absolute;
  top: 10px;
  left: 50%;
  transform: translateX(-50%);
  background-color: rgba(255, 255, 255, 0.9);
  padding: 10px;
  border-radius: 8px;
  z-index: 1000;
  display: flex;
  flex-direction: row;
  gap: 10px;
}
@media screen and (max-width: 768px) {
  .filter-section-desktop {
    display: none;
  }
}

.filter-button-mobile {
  display: none;
}
@media screen and (max-width: 768px) {
  .filter-button-mobile {
    display: flex;
    background-color: #f36d45;
    border-radius: 50%;
    width: 50px;
    height: 50px;
    position: fixed;
    bottom: 20px;
    left: 20px;
    z-index: 1000;
    box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.1);
    justify-content: center;
    align-items: center;
  }
  .filter-button-mobile:hover {
    transform: scale(1.1);
    box-shadow: 0px 8px 15px rgba(0, 0, 0, 0.2);
  }
}`, "",{"version":3,"sources":["webpack://./src/components/google-maps/styles/index.scss"],"names":[],"mappings":"AAAA;EACI,aAAA;EACA,uBAAA;EACA,mBAAA;AACJ;;AAEA;EACI,WAAA;EACA,YAAA;EACA,kBAAA;EACA,mCAAA;EACA,gCAAA;EACA,mCAAA;AACJ;;AAEA;EACI;IACI,qBAAA;IACA,UAAA;EACN;EACE;IACI,UAAA;EACN;EACE;IACI,qBAAA;IACA,UAAA;EACN;AACF;AAEA;EACI,0BAAA;EACA,aAAA;EACA,oCAAA;EACA,6BAAA;EACA,2CAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,2CAAA;EAMA,WAAA;EACA,YAAA;EACA,YAAA;EACA,WAAA;AALJ;AAHI;EACI,qBAAA;EACA,2CAAA;AAKR;AAEI;EAnBJ;IAqBQ,sBAAA;IACA,YAAA;IACA,YAAA;IACA,WAAA;IACA,UAAA;EAAN;AACF;;AAIA;EACI,kBAAA;EACA,SAAA;EACA,SAAA;EACA,2BAAA;EACA,0CAAA;EACA,aAAA;EACA,kBAAA;EACA,aAAA;EACA,aAAA;EACA,mBAAA;EACA,SAAA;AADJ;AAEI;EAZJ;IAaQ,aAAA;EACN;AACF;;AAGA;EACI,aAAA;AAAJ;AACI;EAFJ;IAGQ,aAAA;IACA,yBAAA;IACA,kBAAA;IACA,WAAA;IACA,YAAA;IACA,eAAA;IACA,YAAA;IACA,UAAA;IACA,aAAA;IACA,2CAAA;IACA,uBAAA;IACA,mBAAA;EAEN;EADM;IACI,qBAAA;IACA,2CAAA;EAGV;AACF","sourcesContent":[".pulsation-icon {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n}\n\n.pulsating-circle {\n    width: 30px;\n    height: 30px;\n    border-radius: 50%;\n    background: rgba(88, 137, 236, 0.8);\n    animation: pulsate 1.5s ease-out;\n    animation-iteration-count: infinite;\n}\n\n@keyframes pulsate {\n    0% {\n        transform: scale(0.1);\n        opacity: 0;\n    }\n    50% {\n        opacity: 1;\n    }\n    100% {\n        transform: scale(1.2);\n        opacity: 0;\n    }\n}\n\n.google-button {\n    position: fixed !important;\n    z-index: 1000;\n    background-color: #f36d45 !important;\n    border-radius: 50% !important;\n    box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.1);\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    transition: transform 0.2s, box-shadow 0.2s;\n    &:hover {\n        transform: scale(1.1);\n        box-shadow: 0px 8px 15px rgba(0, 0, 0, 0.2);\n    }\n    // Desktop size\n    width: 30px;\n    height: 50px;\n    bottom: 30px;\n    right: 30px;\n    @media screen and (max-width: 768px) {\n        // Mobile size\n        width: 30px !important;\n        height: 55px;\n        bottom: 20px;\n        right: 20px;\n        left: auto;\n    }\n}\n\n// Desktop filter section\n.filter-section-desktop {\n    position: absolute;\n    top: 10px;\n    left: 50%;\n    transform: translateX(-50%);\n    background-color: rgba(255, 255, 255, 0.9);\n    padding: 10px;\n    border-radius: 8px;\n    z-index: 1000;\n    display: flex;\n    flex-direction: row;\n    gap: 10px;\n    @media screen and (max-width: 768px) {\n        display: none;\n    }\n}\n\n// Mobile filter button\n.filter-button-mobile {\n    display: none;\n    @media screen and (max-width: 768px) {\n        display: flex;\n        background-color: #f36d45;\n        border-radius: 50%;\n        width: 50px;\n        height: 50px;\n        position: fixed;\n        bottom: 20px;\n        left: 20px;\n        z-index: 1000;\n        box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.1);\n        justify-content: center;\n        align-items: center;\n        &:hover {\n            transform: scale(1.1);\n            box-shadow: 0px 8px 15px rgba(0, 0, 0, 0.2);\n        }\n    }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
